import axios from "../lib/axios";
import { helperConstants as constants } from "../helpers/helperConstants";
import useAdaptor from "../lib/swr";
import { ethers } from "ethers";

export default function useGetCollectionNftsByWallet({
  collectionAddress,
  walletAddress,
  limit = 10,
  page = 1,
  search = "",
}: {
  collectionAddress: string;
  walletAddress: string;
  limit?: number;
  page?: number;
  search?: string;
}) {
  let config: { url: string; method: string; params: any } | {};

  if (
    !ethers.utils.isAddress(collectionAddress) ||
    !ethers.utils.isAddress(walletAddress)
  ) {
    config = {};
  } else {
    config = {
      url: `${constants.api.url_new}/users/ownedCollectionNfts`,
      method: constants.httpMethods.get,
      params: { collectionAddress, walletAddress, limit, page, search },
    };
  }

  const fetcher = () =>
    axios(config).then((response) => {
      return response.data;
    });

  return useAdaptor(axios.getUri(config), fetcher);
}
